export enum NpsClassification {
  Promoter = 'Promoter',
  Neutral = 'Neutral',
  Detractor = 'Detractor',
}
